document.addEventListener("DOMContentLoaded", () => {
  const switchers = document.querySelectorAll("[data-locale-switcher]");

  switchers.forEach((switcher) => {
    const toggle = switcher.querySelector(".locale-switcher__toggle");

    toggle.addEventListener("click", (event) => {
      event.stopPropagation();
      const isOpen = switcher.classList.toggle("locale-switcher--open");
      toggle.setAttribute("aria-expanded", isOpen);
    });
  });

  document.addEventListener("click", () => {
    switchers.forEach((switcher) => {
      const toggle = switcher.querySelector(".locale-switcher__toggle");
      switcher.classList.remove("locale-switcher--open");
      toggle.setAttribute("aria-expanded", "false");
    });
  });

  document.querySelectorAll(".locale-switcher [name='locale_code']").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const lang = btn.value;

      const localeMap = {
        en: "",
        de: "/de-de",
      };

      const localePrefixes = ["/de-de"];

      let currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      const currentHash = window.location.hash;

      localePrefixes.forEach((prefix) => {
        if (currentPath === prefix) {
          currentPath = "/";
        } else if (currentPath.startsWith(prefix + "/")) {
          currentPath = currentPath.replace(prefix, "");
        }
      });

      const targetPrefix = localeMap[lang];

      if (targetPrefix === undefined) return;

      sessionStorage.setItem("manual_locale_selected", lang);
      sessionStorage.setItem("visitor_country_redirect_done", "1");

      const targetUrl =
        targetPrefix +
        (currentPath === "/" ? "" : currentPath) +
        currentSearch +
        currentHash;

      window.location.href = targetUrl || "/";
    });
  });
});
